// extracted by mini-css-extract-plugin
export default {"cell":"TableCell_cell__YTzKs"};